import { render, staticRenderFns } from "./DiscussPPT.vue?vue&type=template&id=adb19eb2&scoped=true"
import script from "./DiscussPPT.vue?vue&type=script&lang=js"
export * from "./DiscussPPT.vue?vue&type=script&lang=js"
import style0 from "./DiscussPPT.vue?vue&type=style&index=0&id=adb19eb2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb19eb2",
  null
  
)

export default component.exports